// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Promise, Weaver, WeaverACL, WeaverObject, _, cuid;

  cuid = require('cuid');

  Promise = require('bluebird');

  _ = require('lodash');

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  // For projects, users and nodes, you can specify which users and roles are allowed to read, and which
  // users and roles are allowed to modify.

  // To support this type of security, each of these objects have an access control list,
  // implemented by this WeaverACL class.
  WeaverACL = class WeaverACL extends WeaverObject {
    constructor() {
      super(cuid());
      this._objects = [];
      this._publicRead = false;
      this._publicWrite = false;
      // Locally these are objects, whereas the server expects arrays
      // Converting to arrays before saving in save function
      this._userReadMap = {};
      this._userWriteMap = {};
      this._roleReadMap = {};
      this._roleWriteMap = {};
      this._stored = false;
      this._deleted = false;
    }

    static loadFromServerObject(aclObject) {
      var acl, j, k, l, len, len1, len2, len3, m, ref, ref1, ref2, ref3, u;
      if (aclObject != null) {
        acl = new WeaverACL();
        // Copy
        acl._id = aclObject.id;
        acl._stored = true;
        acl._functionACL = aclObject.functionACL;
        acl._publicRead = aclObject.publicRead;
        acl._publicWrite = aclObject.publicWrite;
        if (aclObject.userRead != null) {
          ref = aclObject.userRead;
          for (j = 0, len = ref.length; j < len; j++) {
            u = ref[j];
            if (u != null) {
              acl._userReadMap[u] = true;
            }
          }
        }
        if (aclObject.userWrite != null) {
          ref1 = aclObject.userWrite;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            u = ref1[k];
            if (u != null) {
              acl._userWriteMap[u] = true;
            }
          }
        }
        if (aclObject.roleRead != null) {
          ref2 = aclObject.roleRead;
          for (l = 0, len2 = ref2.length; l < len2; l++) {
            u = ref2[l];
            if (u != null) {
              acl._roleReadMap[u] = true;
            }
          }
        }
        if (aclObject.roleWrite != null) {
          ref3 = aclObject.roleWrite;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            u = ref3[m];
            if (u != null) {
              acl._roleWriteMap[u] = true;
            }
          }
        }
      }
      return acl;
    }

    // Read from server
    static async load(aclId) {
      var aclObject;
      aclObject = (await GET("acl.read", {
        id: aclId
      }));
      return Weaver.ACL.loadFromServerObject(aclObject);
    }

    static async loadAll(aclIds) {
      var aclObjects, e, i, j, len, results;
      aclObjects = (await GET("acl.read", {
        id: aclIds
      }));
      try {
        results = [];
        for (j = 0, len = aclObjects.length; j < len; j++) {
          i = aclObjects[j];
          results.push(Weaver.ACL.loadFromServerObject(i));
        }
        return results;
      } catch (error) {
        e = error;
        return void 0;
      }
    }

    async save() {
      var trueKeys;
      // Convert to array for all values that are true
      trueKeys = function(object) {
        var key, results, value;
        results = [];
        for (key in object) {
          value = object[key];
          if (value) {
            results.push(key);
          }
        }
        return results;
      };
      // TODO: Create a transferobject, also for WeaverRole and WeaverProject, dont pollute the @
      this._userRead = trueKeys(this._userReadMap);
      this._userWrite = trueKeys(this._userWriteMap);
      this._roleRead = trueKeys(this._roleReadMap);
      this._roleWrite = trueKeys(this._roleWriteMap);
      if (!this._stored) {
        await POST("acl.create", {
          acl: this
        });
        this._stored = true;
        return this;
      } else {
        await POST("acl.update", {
          acl: this
        });
        return this;
      }
    }

    async destroy() {
      await POST("acl.delete", {
        id: this.id()
      });
      this._deleted = true;
    }

    setPublicReadAccess(allowed) {
      return this._publicRead = allowed;
    }

    getPublicReadAccess() {
      return this._publicRead;
    }

    setPublicWriteAccess(allowed) {
      return this._publicWrite = allowed;
    }

    getPublicWriteAccess() {
      return this._publicWrite;
    }

    setUserReadAccess(user, allowed) {
      return this._userReadMap[user.id()] = allowed;
    }

    setUserWriteAccess(user, allowed) {
      return this._userWriteMap[user.id()] = allowed;
    }

    getUserReadAccess(user) {
      return this._userReadMap[user.id()] || false;
    }

    getUserWriteAccess(user) {
      return this._userWriteMap[user.id()] || false;
    }

    setRoleReadAccess(role, allowed) {
      return this._roleReadMap[role.id()] = allowed;
    }

    setRoleWriteAccess(role, allowed) {
      return this._roleWriteMap[role.id()] = allowed;
    }

    getRoleReadAccess(role) {
      return this._roleReadMap[role.id()] || false;
    }

    getRoleWriteAccess(role) {
      return this._roleWriteMap[role.id()] || false;
    }

    static async list() {
      var a, acl, j, len, results;
      acl = (await GET("acl.all"));
      results = [];
      for (j = 0, len = acl.length; j < len; j++) {
        a = acl[j];
        results.push(WeaverACL.loadFromServerObject(a));
      }
      return results;
    }

  };

  module.exports = WeaverACL;

}).call(this);
